export const defaultDeserialize = (source) => {
    try {
        return JSON.parse(source);
    }
    catch (e) {
        return {
            formatVersion: 0,
            children: [],
        };
    }
};
//# sourceMappingURL=defaultDeserialize.js.map